import React from "react";
import { Link } from "react-router-dom";

// SVG lotus/succulent inspired mark in brand purple
const LotusMark = ({ size = 82 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <g stroke="#8e3b9e" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
      {/* center petal */}
      <path d="M50 20 C56 34 56 50 50 62 C44 50 44 34 50 20 Z" />
      {/* inner side petals */}
      <path d="M50 62 C40 56 33 44 33 32 C42 40 49 50 50 62 Z" />
      <path d="M50 62 C60 56 67 44 67 32 C58 40 51 50 50 62 Z" />
      {/* outer side petals */}
      <path d="M50 66 C36 64 24 56 20 44 C33 46 45 54 50 66 Z" />
      <path d="M50 66 C64 64 76 56 80 44 C67 46 55 54 50 66 Z" />
      {/* bottom petals */}
      <path d="M50 70 C40 74 27 74 19 68 C30 62 43 62 50 70 Z" />
      <path d="M50 70 C60 74 73 74 81 68 C70 62 57 62 50 70 Z" />
      {/* small center bud */}
      <path d="M50 40 C53 46 53 54 50 58 C47 54 47 46 50 40 Z" />
    </g>
  </svg>
);

export default function Logo({ compact = false }) {
  if (compact) {
    return (
      <Link to="/" className="flex items-center gap-3 group">
        <LotusMark size={44} />
        <div className="leading-none">
          <div className="font-script text-teal text-2xl">Holistic Intuitive Nutrition</div>
          <div className="text-purple text-[10px] font-medium tracking-name mt-0.5">
            KAMLA DAS
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link to="/" className="flex flex-col items-center select-none">
      <LotusMark size={92} />
      <div className="font-script text-teal text-4xl md:text-5xl mt-1">
        Holistic Intuitive Nutrition
      </div>
      <div className="text-purple text-sm md:text-base font-medium tracking-name mt-3 ml-[0.42em]">
        KAMLA DAS
      </div>
    </Link>
  );
}
